import {
  Box,
  FormControl,
  FormLabel,
  TextField,
  FormControlLabel,
  Typography,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import { InputWrapper, LabelStyle } from "../../Common/styles/form";
import TipTapFormik from "../../Tiptap/TipTapFormik";
import { SurveyEmailContentVariableChips } from "../surveyEmailContentVariables";
import SurveyInviteTemplateBanner from "../SurveyInviteTemplateBanner";

const Reminders = ({
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  values,
  studyId,
}: any) => {
  return (
    <>
      {values?.isReminder === true && studyId && (
        <SurveyInviteTemplateBanner studyId={studyId} />
      )}
      {values?.isReminder === true && <SurveyEmailContentVariableChips />}
      <FormControl sx={{ ...InputWrapper, mb: 1 }}>
        <Box>
          <FormControlLabel
            label={
              <Typography
                variant="subtitle1"
                fontWeight={"regular"}
                color="text.primary"
              >
                Send a reminder if the survey is not yet completed
              </Typography>
            }
            control={
              <Checkbox
                checked={values?.isReminder === true}
                onChange={(event) => {
                  setFieldValue("isReminder", event.target.checked);
                }}
              />
            }
          />
        </Box>
      </FormControl>

      {values?.isReminder === true && (
        <>
          <FormControl sx={{ ...InputWrapper, mb: 1 }}>
            <FormLabel sx={LabelStyle} htmlFor="send-reminder">
              Send Reminder After(Days) <span style={{ color: "red" }}>*</span>
            </FormLabel>
            <TextField
              placeholder="Send Reminder After (Days)"
              id="send-reminder"
              {...getFieldProps("reminderPattern")}
              error={
                touched?.reminderPattern && errors?.reminderPattern
                  ? true
                  : false
              }
              helperText={
                touched?.reminderPattern && errors?.reminderPattern
                  ? (errors?.reminderPattern as string)
                  : "Eg: 5,10,15 will send reminder after 5th, 10th and 15th day after the survey is sent, if the survey is incomplete"
              }
            />
          </FormControl>
          <FormControl sx={{ ...InputWrapper, mb: 1 }}>
            <FormLabel sx={LabelStyle} htmlFor="email-subject">
              Email Subject <span style={{ color: "red" }}>*</span>
            </FormLabel>
            <TextField
              placeholder="Subject"
              id="email-subject"
              {...getFieldProps("emailSubject")}
              error={
                touched?.emailSubject && errors?.emailSubject ? true : false
              }
              helperText={
                touched?.emailSubject && errors?.emailSubject
                  ? (errors?.emailSubject as string)
                  : " "
              }
            />
          </FormControl>
          <FormControl sx={InputWrapper}>
            <FormLabel sx={LabelStyle} htmlFor="message-body">
              Message Body <span style={{ color: "red" }}>*</span>
            </FormLabel>
            <TipTapFormik name="emailBody" setFieldValue={setFieldValue} />
            {touched?.emailBody && errors?.emailBody && (
              <FormHelperText error>
                {errors?.emailBody as string}
              </FormHelperText>
            )}
            {/* <TextField
              multiline
              placeholder="Message Body"
              minRows={4}
              id="message-body"
              {...getFieldProps("emailBody")}
              error={touched?.emailBody && errors?.emailBody ? true : false}
              helperText={
                touched?.emailBody && errors?.emailBody
                  ? (errors?.emailBody as string)
                  : " "
              }
            /> */}
          </FormControl>
        </>
      )}
    </>
  );
};

export default Reminders;
